import { AdditionalInfoRequest } from "../../models/additional-info-request";
import { ManualLocationProduct } from "../../models/manual-location-product";
import { ClosedDay } from "../../models/private-location/closed-day";
import { Tag } from "../../models/tag";

export interface AddManualLocationRequest {
    id?: string;
    planId?: string;
    planName?: string;
    locationId: string;
    locationName: string;
    latitude?: number;
    longitude?: number;
    address: string;
    country: string;
    postalCode?: string;
    city?: string;
    houseNo: string;
    litra: string;
    floor: string;
    door: string;
    pickupCapacityType1?: number;
    pickupCapacityType2?: number;
    pickupCapacityType3?: number;
    deliveryCapacityType1?: number;
    deliveryCapacityType2?: number;
    deliveryCapacityType3?: number;
    day: number;
    fromTime: string;
    toTime: string;
    locationAdditionalInfo?: string;
    productAdditionalInfo?: string;
    tenantLocationId?: string | undefined;
    closedDays?: ClosedDay[] | null;
    serviceTime:string;
    serviceToTime: string; 
    distributionLaneId: string | undefined;
    stopTime: string | undefined;
    shouldVisitIfNoService: boolean | undefined;
    IsInfrastructure: boolean | undefined;
    productId: string;
    prodId:string;
    productName:string;
    productTemplate:string;
    activityName: string;
    locationGroupId?:string | null;
    isLocationGroup?: boolean;
}